import { Component } from '@angular/core';

import { DevFuncConfirmInterface } from '../../base/confirm/dev-func-confirm.interface';

@Component({
    template: `
    <div>
        <div class="title">Are you sure to reboot the device(s)?</div>
        <div class="border p-2 mt-2">{{ _monitorDeviceNames }}</div>
    </div>
    `,
    styleUrls: ['../../base/base-config-form.component.css'],
    standalone: false
})
export class RebootConfirmSubFormComponent implements DevFuncConfirmInterface {
    private _actionData: any;
    set actionData(data: any) {
        this._actionData = data;
        if (this._actionData) {
            this._monitorDeviceNames = this._actionData.deviceNames;
        }
    }

    allowSubmitCallback: (isAllow: boolean) => void;

    _monitorDeviceNames: string;
}